import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import './Common.css';
import './responsive.css';
import { useEffect } from 'react';
import { myFunction } from "./common.js";
import Home from './Home';
import About from './About';
import Webwasa from './All-services-dynamic/Web-WASA'
import Mobileandroid from './All-services-dynamic/Mobile-Android-IOS'
import NetworkingInfrastructure from './All-services-dynamic/Networking-Infrastructure'
import SCR from './All-services-dynamic/Source-code-review'
import SCA from './All-services-dynamic/Software-Composition-Analysis'
import API from './All-services-dynamic/API-Security-Testing'
import Redteam from './All-services-dynamic/Red-Team-Assessment'
import IOT from './All-services-dynamic/IOT'
import OT from './All-services-dynamic/OT'
import ConfigurationReview from './All-services-dynamic/Configuration-Review'
import MedicalDeviceSecurity from './All-services-dynamic/Medical-Device-Security'
import ISO from './All-services-dynamic/ISO'
import SOC from './All-services-dynamic/SOC'
import GDPR from './All-services-dynamic/GDPR'
import HIPPA from './All-services-dynamic/Hippa'
import SARDL from './All-services-dynamic/SAR-DL'
import ASPSIGN from './All-services-dynamic/ASP-esign'
import ISAUDIT from './All-services-dynamic/IS-Audit'
import DPDP from './All-services-dynamic/DPDP'
import Contact from './Contact-us';
import SamplePage from './sample-page';
import NotFound from './NotFound';
import ComingSoon from "./ComingSoon";
import LinkInterceptor from "./LinkInterceptor";
import Header from './Header';
import Footer from './Footer';


function App() {
  useEffect(() => {
    myFunction();
  }, []);

  return (
    <Router>
      <LinkInterceptor />
      <Header />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/About" element={<About />} />
        <Route exact path="/Web-WASA" element={<Webwasa />} />
        <Route exact path="/Mobile-Android-IOS" element={<Mobileandroid />} />
        <Route exact path="/Networking-Infrastructure" element={<NetworkingInfrastructure />} />
        <Route exact path="/Source-code-review" element={<SCR />} />
        <Route exact path="/Software-Composition-Analysis" element={<SCA />} />
        <Route exact path="/API-Security-Testing" element={<API />} />
        <Route exact path="/Red-Team-Assessment" element={<Redteam />} />
        <Route exact path="/IOT" element={<IOT />} />
        <Route exact path="/OT" element={<OT />} />
        <Route exact path="/Configuration-Review" element={<ConfigurationReview />} />
        <Route exact path="/Medical-Device-Security" element={<MedicalDeviceSecurity />} />
        <Route exact path="/ISO" element={<ISO />} />
        <Route exact path="/SOC" element={<SOC />} />
        <Route exact path="/GDPR" element={<GDPR />} />
        <Route exact path="/Hippa" element={<HIPPA />} />
        <Route exact path="/SAR-DL" element={<SARDL />} />
        <Route exact path="/ASP-esign" element={<ASPSIGN />} />
        <Route exact path="/IS-Audit" element={<ISAUDIT />} />
        <Route exact path="/DPDP" element={<DPDP />} />
        <Route exact path="/Contact-us" element={<Contact />} />
        <Route exact path="/sample-page" element={<SamplePage />} />
        {/* <Route exact path="*" element={<NotFound />} /> */}
        <Route exact path="/coming-soon" element={<ComingSoon />} />
        <Route exact path="*" element={<ComingSoon />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;